/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-file-type-icon',
    template: `
        @switch (ext?.toLowerCase()) {
            @case ('pdf') {
                <img src="./assets/file-types/file_type_pdf_icon_32.png" height="28" width="28" alt="PDF">
            }
            @case ('doc') {
                <img src="./assets/file-types/word_32.png" height="28" width="28" alt="Doc">
            }
            @case ('docx') {
                <img src="./assets/file-types/word_32.png" height="28" width="28" alt="Docx">
            }
            @case ('xls') {
                <img src="./assets/file-types/excel_32.png" height="28" width="28" alt="Xls">
            }
            @case ('xlsx') {
                <img src="./assets/file-types/excel_32.png" height="28" width="28" alt="Xlsx">
            }
            @case ('msg') {
                <img src="./assets/file-types/outlook.png" height="28" width="28" alt="Msg">
            }
            @case ('jpg') {
                <img src="./assets/file-types/icon-image.png" height="28" width="28" alt="Jpg">
            }
            @case ('jpeg') {
                <img src="./assets/file-types/icon-image.png" height="28" width="28" alt="Jpeg">
            }
            @case ('png') {
                <img src="./assets/file-types/icon-image.png" height="28" width="28" alt="Png">
            }
            @case ('gif') {
                <img src="./assets/file-types/icon-image.png" height="28" width="28" alt="Gif">
            }
            @case ('webp') {
                <img src="./assets/file-types/icon-image.png" height="28" width="28" alt="Webp">
            }
            @default {
                <mat-icon color="primary">attachment</mat-icon>
            }
        }
    `,
    imports: [MatIconModule],
})
export class FileTypeIconComponent {
    @Input() ext: string;
}
